import { render } from "./NavSubMenu.vue?vue&type=template&id=5c007cb4"
import script from "./NavSubMenu.vue?vue&type=script&lang=js"
export * from "./NavSubMenu.vue?vue&type=script&lang=js"
script.render = render

export default script